import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Home, Loader2 } from "lucide-react";

import { isAuthenticated, logout } from "../../services/authService";

export const AddinHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loggingOut, setLoggingOut] = useState(false);
  if (
    location.pathname === "/login" ||
    location.pathname === "/okta-callback"
  ) {
    return null;
  } 
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const depth = pathSegments.length;
  const showBack = depth >= 1;
  const showHome = depth >= 2;

  const handleBack = () => {
    if (showBack) navigate(-1);
  };

  const handleHome = () => navigate("/");

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await logout();
      navigate("/login", { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <header className="flex items-center justify-between border-b border-sidebar-border bg-header-bg px-3 py-3">
      <div className="flex items-center gap-2">
        {showBack && (
          <button
            type="button"
            onClick={handleBack}
            className="rounded p-1 text-foreground hover:bg-accent"
            aria-label="Back"
          >
            <ArrowLeft className="h-4 w-4 text-gray-600" />
          </button>
        )}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-indigo-600 to-purple-700 rounded flex items-center justify-center text-white font-bold text-sm">
            IQ
          </div>
          <h2 className="font-semibold text-gray-900">IntelliDocSuite</h2>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {isAuthenticated() && (
          <button
            type="button"
            onClick={() => void handleLogout()}
            disabled={loggingOut}
            className="inline-flex items-center gap-1.5 rounded border border-sidebar-border px-2 py-1 text-xs text-foreground hover:bg-accent disabled:pointer-events-none disabled:opacity-60"
            aria-label={loggingOut ? "Logging out" : "Logout"}
          >
            {loggingOut ? (
              <>
                <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden />
                Logging out…
              </>
            ) : (
              "Logout"
            )}
          </button>
        )}
        {showHome && (
          <button
            type="button"
            onClick={handleHome}
            className="inline-flex items-center gap-1 rounded-full bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            aria-label="Home"
          >
            <Home className="h-4 w-4" />
            Home
          </button>
        )}
        {/* <button
          type="button"
          onClick={handleClose}
          className="rounded p-1 text-foreground hover:bg-accent"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button> */}
      </div>
    </header>
  );
};
